import * as React from 'react';

const CarretIcon = () => {
	return (
		<svg width='38' height='14' viewBox='0 0 38 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path d='M19 14C17.5 14 17.5 9.53674e-07 0 1.23978e-05L19 0C19 4 19 9.49999 19 14Z' />
			<path d='M19 14C20.5 14 20.5 9.53674e-07 38 1.23978e-05L19 0C19 4 19 9.49999 19 14Z' />
		</svg>
	);
};
export default CarretIcon;
